import { render, staticRenderFns } from "./ReportStepRequirements.vue?vue&type=template&id=85948ebc&scoped=true"
import script from "./ReportStepRequirements.vue?vue&type=script&lang=js"
export * from "./ReportStepRequirements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85948ebc",
  null
  
)

export default component.exports